import { useState } from 'react';
import Header from '../header/Header';
import Modal from '../modal/Modal';
import Gallery from '../gallery/Gallery';

import './content.css';
import UserAppContext from '../../hook/UserAppContext';

const Content = ({isIcon, isSetIcon, isTheme, isSetTheme}) => {

      const [obj, setObj] = useState([]);
      const [modal, setModal] = useState(false);
      const {user} = UserAppContext()

      if(user.length === 0) return;

      const {galleries} = user.user;

      return (
            <div className="content">
                  <Modal isObj={obj} isModal={modal} isSetModal={setModal} />
                  <Header isIcon={isIcon} isSetIcon={isSetIcon} isTheme={isTheme} isSetTheme={isSetTheme}/>
                  <div className="gallery_content">
                        <Gallery galleries={galleries} isSetObj={setObj} isSetModal={setModal} />
                  </div>
                  <div className="footer">
                        <span>Theme - xatme.com</span>
                        <p>&copy; 2023 - JasonOficial - 1202</p>
                  </div>
            </div>
      )
}

export default Content;